// Source of truth for the public CLEMENT COURSE I price list.
// Verbatim from the founder's approved list (14-course-one-price-list.md).
// Never invent figures here. Watches without an approved tier
// are surfaced as "Price to be assigned".

export const ALLOCATION_INTRO = {
  overline: "Allocation & Pricing",
  title: "Course I · Allocation",
  body: [
    "Allocation across the COURSE I catalog is set by collection tier. Each tier carries a defined production count and a target figure expressed in United States dollars.",
    "Pricing is reconfirmed at the moment of allocation following final movement selection, materials confirmation, and manufacturing review.",
    "Allocations are individually numbered and released exclusively through the Private Registry.",
  ],
  footnote:
    "These are pre-launch target figures. Final retail pricing is confirmed after CAD, sample build, movement selection, materials, and manufacturing quotes.",
};

export const COLLECTIONS = [
  {
    slug: "club",
    label: "Club Collection",
    cadence: "Pastel scenic dials · entry tier into the house",
    watches: [
      {
        name: "Magnolia Pearl",
        direction: "Soft pearl floral course dial",
        priceUSD: 9_500,
        pieces: 500,
      },
      {
        name: "Magnolia Green",
        direction: "Magnolia fairway scene with green accents",
        priceUSD: 9_500,
        pieces: 500,
      },
      {
        name: "Rose Dawn",
        direction: "Rose sunrise fairway, feminine club hands",
        priceUSD: 10_500,
        pieces: 500,
      },
      {
        name: "Lavender Links",
        direction: "Lavender sunset course dial",
        priceUSD: 10_500,
        pieces: 500,
      },
      {
        name: "Desert Bloom",
        direction: "Sonoran sunset · cactus and wildflowers framing a hidden green",
        priceUSD: 9_500,
        pieces: 500,
      },
      {
        name: "Pearl Clubhouse",
        direction: "Mother-of-pearl sky over the clubhouse · the most jewelry-watch of the line",
        priceUSD: 9_500,
        pieces: 500,
      },
      {
        name: "Garden Green",
        direction: "Rose garden landscape with a gazebo on the green",
        priceUSD: 9_500,
        pieces: 500,
      },
    ],
  },
  {
    slug: "steel-club",
    label: "Steel Club Collection",
    cadence: "Stainless steel members' editions · 1 of 100 per club",
    watches: [
      {
        name: "Azure Club",
        direction: "Stainless steel case · azure-blue guilloché dial · sculpted putter and iron hands",
        priceUSD: 29_500,
        pieces: 100,
      },
      {
        name: "Chameleon Club",
        direction: "Stainless steel case · iridescent multi-spectrum dial · contour topographic engraving",
        priceUSD: 34_500,
        pieces: 100,
      },
    ],
  },
  {
    slug: "scenic-dial-mens",
    label: "Scenic Dial · Men's",
    cadence: "Hand-painted dials · 41 mm stainless · per-scene capsule",
    watches: [
      {
        name: "Heritage Fairway",
        direction: "Championship fairway, parkland greens, classic links composition",
        priceUSD: 29_500,
        pieces: 100,
      },
      {
        name: "Alpine Hour",
        direction: "Mountain course at golden hour · snow-capped peaks behind an alpine fairway",
        priceUSD: 29_500,
        pieces: 100,
      },
      {
        name: "Ocean Cliffs",
        direction: "Headland green over the Pacific · mineral cliffs and surf",
        priceUSD: 32_500,
        pieces: 100,
      },
      {
        name: "Turquoise Coast",
        direction: "Tropical Caribbean headland · resort fairway and crystalline water",
        priceUSD: 32_500,
        pieces: 100,
      },
    ],
  },
  {
    slug: "reserve",
    label: "Reserve Collection",
    cadence: "Precious-metal dial direction",
    watches: [
      {
        name: "Rosewood Charcoal",
        direction: "Rose-gold warmth over charcoal restraint",
        priceUSD: 19_500,
        pieces: 250,
      },
      {
        name: "Champagne Green",
        direction: "White-gold direction with champagne-green dial language",
        priceUSD: 22_500,
        pieces: 250,
      },
      {
        name: "Golden Fairway",
        direction: "Yellow-gold fairway expression with emerald presence",
        priceUSD: 24_500,
        pieces: 250,
      },
    ],
  },
  {
    slug: "championship",
    label: "Championship Collection",
    cadence: "Ceramic & gold flagship",
    watches: [
      {
        name: "Midnight Links",
        direction:
          "Black ceramic tension, polished gold accents, private-club presence",
        priceUSD: 39_500,
        pieces: 100,
      },
    ],
  },
  {
    slug: "jewel",
    label: "Jewel Collection",
    cadence: "Two-tone gold · jewelry-bracelet architecture",
    watches: [
      {
        name: "Jewel Bracelet",
        direction: "Scenic Petite case with bracelet-jewelry architecture",
        priceUSD: 49_500,
        pieces: 100,
      },
      {
        name: "Gilded",
        direction: "Two-tone gilded case · warm champagne guilloché dial · gold-finished bezel and crown · dress-edition of the Club line",
        priceUSD: 49_500,
        pieces: 100,
      },
    ],
  },
  {
    slug: "special-edition",
    label: "Special Edition",
    cadence: "Ultra-slim Scenic Petite · individually numbered",
    watches: [
      {
        name: "Petite Slim Collector Edition",
        direction: "Ultra-thin Scenic Petite collector configuration",
        priceUSD: 79_500,
        pieces: 25,
      },
    ],
  },
  {
    slug: "future",
    label: "Future Special Releases",
    cadence: "Tournament and tribute references",
    watches: [
      {
        name: "Major Championship Edition",
        direction: "Tournament-level complication and finishing direction",
        priceUSD: 99_500,
        pieces: 50,
      },
      {
        name: "Masters Tribute Edition",
        direction: "Green and gold ceremonial golf tribute direction",
        priceUSD: 125_000,
        pieces: 25,
      },
      {
        name: "Petite Masters Tribute Edition",
        direction: "High-jewelry emerald and magnolia Petite counterpart",
        priceUSD: 125_000,
        pieces: 25,
      },
      {
        name: "Founder's Signature Edition",
        direction: "Founder-approved signature allocation",
        priceUSD: 150_000,
        pieces: 10,
      },
      {
        name: "Petite Founder's Signature Edition",
        direction:
          "Feminine founder heirloom with jewelry bracelet architecture",
        priceUSD: 150_000,
        pieces: 10,
      },
      {
        name: "Grand Champion Edition",
        direction: "Bespoke halo execution for private allocation",
        privateAllocation: true,
        pieces: "1–5",
      },
      {
        name: "Petite Grand Masterpiece Edition",
        direction:
          "Bespoke feminine halo execution for private allocation",
        privateAllocation: true,
        pieces: "1–5",
      },
    ],
  },
  {
    slug: "scenic-halo",
    label: "Scenic Halo Editions",
    cadence: "Master · Founder's · Grand Champion tiers · four scenes",
    watches: [
      // Turquoise Coast
      {
        name: "Scenic Turquoise Coast Master Edition",
        direction: "Turquoise coastal golf miniature-art dial",
        priceUSD: 125_000,
        pieces: 25,
      },
      {
        name: "Scenic Turquoise Coast Founder's Edition",
        direction: "Founder-signed turquoise coast scenic heirloom",
        priceUSD: 150_000,
        pieces: 10,
      },
      {
        name: "Scenic Turquoise Coast Grand Champion Edition",
        direction: "Bespoke turquoise coast scenic halo",
        privateAllocation: true,
        pieces: "1–5",
      },
      // Orchid Fairway
      {
        name: "Scenic Orchid Fairway Master Edition",
        direction: "Orchid floral fairway miniature-art dial",
        priceUSD: 125_000,
        pieces: 25,
      },
      {
        name: "Scenic Orchid Fairway Founder's Edition",
        direction: "Founder-signed orchid fairway scenic heirloom",
        priceUSD: 150_000,
        pieces: 10,
      },
      {
        name: "Scenic Orchid Fairway Grand Champion Edition",
        direction: "Bespoke orchid scenic halo with purple sapphire direction",
        privateAllocation: true,
        pieces: "1–5",
      },
      // Ocean Cliffs
      {
        name: "Scenic Ocean Cliffs Master Edition",
        direction: "Ocean-cliff golf miniature-art dial",
        priceUSD: 125_000,
        pieces: 25,
      },
      {
        name: "Scenic Ocean Cliffs Founder's Edition",
        direction: "Founder-signed ocean cliffs scenic heirloom",
        priceUSD: 150_000,
        pieces: 10,
      },
      {
        name: "Scenic Ocean Cliffs Grand Champion Edition",
        direction: "Bespoke ocean cliffs scenic halo",
        privateAllocation: true,
        pieces: "1–5",
      },
      // Pearl Clubhouse
      {
        name: "Scenic Pearl Clubhouse Master Edition",
        direction: "Pearl clubhouse miniature-art dial",
        priceUSD: 125_000,
        pieces: 25,
      },
      {
        name: "Scenic Pearl Clubhouse Founder's Edition",
        direction: "Founder-signed pearl clubhouse scenic heirloom",
        priceUSD: 150_000,
        pieces: 10,
      },
      {
        name: "Scenic Pearl Clubhouse Grand Champion Edition",
        direction: "Bespoke pearl clubhouse scenic halo",
        privateAllocation: true,
        pieces: "1–5",
      },
    ],
  },
];

// Lookup the founder-approved figure for a catalog-page watch slug.
// Returns null when the watch has no approved tier yet (e.g. Azure, Chameleon).
const SLUG_TO_PRICE = {
  // Launch / Reserve
  "rosewood-charcoal": { priceUSD: 19_500, pieces: 250, tier: "Reserve" },
  "champagne-green": { priceUSD: 22_500, pieces: 250, tier: "Reserve" },
  "golden-fairway": { priceUSD: 24_500, pieces: 250, tier: "Reserve" },
  "midnight-links": { priceUSD: 39_500, pieces: 100, tier: "Championship" },
  // Club Collection (Scenic Petite entry tier)
  "magnolia-pearl": { priceUSD: 9_500, pieces: 500, tier: "Club" },
  "magnolia-green": { priceUSD: 9_500, pieces: 500, tier: "Club" },
  "rose-dawn": { priceUSD: 10_500, pieces: 500, tier: "Club" },
  "lavender-links": { priceUSD: 10_500, pieces: 500, tier: "Club" },
  "desert-bloom": { priceUSD: 9_500, pieces: 500, tier: "Club" },
  "pearl-clubhouse": { priceUSD: 9_500, pieces: 500, tier: "Club" },
  "garden-green": { priceUSD: 9_500, pieces: 500, tier: "Club" },
  // Steel Club Collection (men's stainless, 1 of 100)
  azure: { priceUSD: 29_500, pieces: 100, tier: "Steel Club" },
  chameleon: { priceUSD: 34_500, pieces: 100, tier: "Steel Club" },
  // Scenic Dial · Men's
  "heritage-fairway": { priceUSD: 29_500, pieces: 100, tier: "Scenic Dial" },
  "alpine-hour": { priceUSD: 29_500, pieces: 100, tier: "Scenic Dial" },
  "ocean-cliffs": { priceUSD: 32_500, pieces: 100, tier: "Scenic Dial" },
  "turquoise-coast": { priceUSD: 32_500, pieces: 100, tier: "Scenic Dial" },
  // Jewel Collection
  "jewel-bracelet": { priceUSD: 49_500, pieces: 100, tier: "Jewel" },
  gilded: { priceUSD: 49_500, pieces: 100, tier: "Jewel" },
  // Special Edition
  "slim-concept": { priceUSD: 79_500, pieces: 25, tier: "Special Edition" },
};

export function lookupAllocation(slug) {
  return SLUG_TO_PRICE[slug] || null;
}

// Format a USD figure as `9,500 USD` (luxe spec-sheet styling).
// Resolve a watch by its Allocation-page display name to its catalog deep-link.
// Returns { to } or null when the watch has no catalog presence yet
// (e.g. future-special-releases and concept halo editions).
const NAME_TO_CATALOG = {
  // Club Collection (Scenic Petite)
  "Magnolia Pearl": { route: "scenic-petite", slug: "magnolia-pearl" },
  "Magnolia Green": { route: "scenic-petite", slug: "magnolia-green" },
  "Rose Dawn": { route: "scenic-petite", slug: "rose-dawn" },
  "Lavender Links": { route: "scenic-petite", slug: "lavender-links" },
  "Desert Bloom": { route: "scenic-petite", slug: "desert-bloom" },
  "Pearl Clubhouse": { route: "scenic-petite", slug: "pearl-clubhouse" },
  "Garden Green": { route: "scenic-petite", slug: "garden-green" },
  // Reserve Collection (Launch)
  "Rosewood Charcoal": { route: "launch", slug: "rosewood-charcoal" },
  "Champagne Green": { route: "launch", slug: "champagne-green" },
  "Golden Fairway": { route: "launch", slug: "golden-fairway" },
  // Championship Collection (Launch)
  "Midnight Links": { route: "launch", slug: "midnight-links" },
  // Steel Club Collection (Club catalog)
  "Azure Club": { route: "club", slug: "azure" },
  "Chameleon Club": { route: "club", slug: "chameleon" },
  // Scenic Dial · Men's
  "Heritage Fairway": { route: "scenic-dial", slug: "heritage-fairway" },
  "Alpine Hour": { route: "scenic-dial", slug: "alpine-hour" },
  "Ocean Cliffs": { route: "scenic-dial", slug: "ocean-cliffs" },
  "Turquoise Coast": { route: "scenic-dial", slug: "turquoise-coast" },
  // Jewel Collection
  "Jewel Bracelet": { route: "scenic-petite", slug: "jewel-bracelet" },
  Gilded: { route: "club", slug: "gilded" },
  // Founders Collection
  "Petite Slim Collector Edition": {
    route: "scenic-petite",
    slug: "slim-concept",
  },
};

export function getCatalogLink(watchName) {
  const entry = NAME_TO_CATALOG[watchName];
  if (!entry) return null;
  return `/collection/${entry.route}#${entry.slug}`;
}

export function formatUSD(amount) {
  return `${amount.toLocaleString("en-US")} USD`;
}
